var cov_1yd3xfa3ku = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/hoc/draggable.tsx",
      hash = "67c0b64fe96b02c75228d14cbb2eb26b6b005eb3",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/hoc/draggable.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 32
        },
        end: {
          line: 16,
          column: 1
        }
      },
      "1": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 18
        }
      },
      "2": {
        start: {
          line: 31,
          column: 6
        },
        end: {
          line: 31,
          column: 60
        }
      },
      "3": {
        start: {
          line: 32,
          column: 6
        },
        end: {
          line: 32,
          column: 50
        }
      },
      "4": {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 33,
          column: 56
        }
      },
      "5": {
        start: {
          line: 37,
          column: 25
        },
        end: {
          line: 37,
          column: 35
        }
      },
      "6": {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 44,
          column: 7
        }
      },
      "7": {
        start: {
          line: 39,
          column: 8
        },
        end: {
          line: 39,
          column: 31
        }
      },
      "8": {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 40,
          column: 31
        }
      },
      "9": {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 41,
          column: 28
        }
      },
      "10": {
        start: {
          line: 42,
          column: 8
        },
        end: {
          line: 42,
          column: 24
        }
      },
      "11": {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 43,
          column: 60
        }
      },
      "12": {
        start: {
          line: 43,
          column: 36
        },
        end: {
          line: 43,
          column: 60
        }
      },
      "13": {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 48,
          column: 25
        }
      },
      "14": {
        start: {
          line: 52,
          column: 6
        },
        end: {
          line: 52,
          column: 61
        }
      },
      "15": {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 53,
          column: 62
        }
      },
      "16": {
        start: {
          line: 54,
          column: 6
        },
        end: {
          line: 54,
          column: 65
        }
      },
      "17": {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 58,
          column: 64
        }
      },
      "18": {
        start: {
          line: 59,
          column: 6
        },
        end: {
          line: 59,
          column: 65
        }
      },
      "19": {
        start: {
          line: 60,
          column: 6
        },
        end: {
          line: 60,
          column: 68
        }
      },
      "20": {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 64,
          column: 32
        }
      },
      "21": {
        start: {
          line: 64,
          column: 26
        },
        end: {
          line: 64,
          column: 32
        }
      },
      "22": {
        start: {
          line: 65,
          column: 6
        },
        end: {
          line: 65,
          column: 30
        }
      },
      "23": {
        start: {
          line: 66,
          column: 6
        },
        end: {
          line: 66,
          column: 30
        }
      },
      "24": {
        start: {
          line: 67,
          column: 6
        },
        end: {
          line: 67,
          column: 26
        }
      },
      "25": {
        start: {
          line: 68,
          column: 6
        },
        end: {
          line: 68,
          column: 22
        }
      },
      "26": {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 69,
          column: 58
        }
      },
      "27": {
        start: {
          line: 69,
          column: 34
        },
        end: {
          line: 69,
          column: 58
        }
      },
      "28": {
        start: {
          line: 73,
          column: 6
        },
        end: {
          line: 73,
          column: 32
        }
      },
      "29": {
        start: {
          line: 73,
          column: 26
        },
        end: {
          line: 73,
          column: 32
        }
      },
      "30": {
        start: {
          line: 74,
          column: 6
        },
        end: {
          line: 74,
          column: 52
        }
      },
      "31": {
        start: {
          line: 74,
          column: 46
        },
        end: {
          line: 74,
          column: 52
        }
      },
      "32": {
        start: {
          line: 76,
          column: 17
        },
        end: {
          line: 76,
          column: 53
        }
      },
      "33": {
        start: {
          line: 77,
          column: 17
        },
        end: {
          line: 77,
          column: 53
        }
      },
      "34": {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 78,
          column: 38
        }
      },
      "35": {
        start: {
          line: 78,
          column: 32
        },
        end: {
          line: 78,
          column: 38
        }
      },
      "36": {
        start: {
          line: 80,
          column: 6
        },
        end: {
          line: 80,
          column: 30
        }
      },
      "37": {
        start: {
          line: 81,
          column: 6
        },
        end: {
          line: 81,
          column: 30
        }
      },
      "38": {
        start: {
          line: 83,
          column: 6
        },
        end: {
          line: 83,
          column: 76
        }
      },
      "39": {
        start: {
          line: 83,
          column: 29
        },
        end: {
          line: 83,
          column: 76
        }
      },
      "40": {
        start: {
          line: 87,
          column: 6
        },
        end: {
          line: 87,
          column: 32
        }
      },
      "41": {
        start: {
          line: 87,
          column: 26
        },
        end: {
          line: 87,
          column: 32
        }
      },
      "42": {
        start: {
          line: 88,
          column: 6
        },
        end: {
          line: 88,
          column: 27
        }
      },
      "43": {
        start: {
          line: 89,
          column: 6
        },
        end: {
          line: 89,
          column: 25
        }
      },
      "44": {
        start: {
          line: 90,
          column: 6
        },
        end: {
          line: 90,
          column: 54
        }
      },
      "45": {
        start: {
          line: 90,
          column: 32
        },
        end: {
          line: 90,
          column: 54
        }
      },
      "46": {
        start: {
          line: 94,
          column: 6
        },
        end: {
          line: 94,
          column: 83
        }
      },
      "47": {
        start: {
          line: 98,
          column: 2
        },
        end: {
          line: 98,
          column: 13
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 13,
            column: 3
          }
        },
        loc: {
          start: {
            line: 13,
            column: 16
          },
          end: {
            line: 13,
            column: 18
          }
        },
        line: 13
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 14,
            column: 3
          }
        },
        loc: {
          start: {
            line: 14,
            column: 11
          },
          end: {
            line: 14,
            column: 13
          }
        },
        line: 14
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        },
        loc: {
          start: {
            line: 15,
            column: 14
          },
          end: {
            line: 15,
            column: 16
          }
        },
        line: 15
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 18,
            column: 22
          },
          end: {
            line: 18,
            column: 23
          }
        },
        loc: {
          start: {
            line: 18,
            column: 87
          },
          end: {
            line: 99,
            column: 1
          }
        },
        line: 18
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 28,
            column: 5
          }
        },
        loc: {
          start: {
            line: 28,
            column: 26
          },
          end: {
            line: 34,
            column: 5
          }
        },
        line: 28
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 36,
            column: 5
          }
        },
        loc: {
          start: {
            line: 36,
            column: 24
          },
          end: {
            line: 45,
            column: 5
          }
        },
        line: 36
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        },
        loc: {
          start: {
            line: 47,
            column: 27
          },
          end: {
            line: 49,
            column: 5
          }
        },
        line: 47
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 51,
            column: 5
          }
        },
        loc: {
          start: {
            line: 51,
            column: 16
          },
          end: {
            line: 55,
            column: 5
          }
        },
        line: 51
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 57,
            column: 5
          }
        },
        loc: {
          start: {
            line: 57,
            column: 19
          },
          end: {
            line: 61,
            column: 5
          }
        },
        line: 57
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        },
        loc: {
          start: {
            line: 63,
            column: 53
          },
          end: {
            line: 70,
            column: 5
          }
        },
        line: 63
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 72,
            column: 5
          }
        },
        loc: {
          start: {
            line: 72,
            column: 30
          },
          end: {
            line: 84,
            column: 5
          }
        },
        line: 72
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        },
        loc: {
          start: {
            line: 86,
            column: 20
          },
          end: {
            line: 91,
            column: 5
          }
        },
        line: 86
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 93,
            column: 5
          }
        },
        loc: {
          start: {
            line: 93,
            column: 13
          },
          end: {
            line: 95,
            column: 5
          }
        },
        line: 93
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 44,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 44,
            column: 7
          }
        }, {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 44,
            column: 7
          }
        }],
        line: 38
      },
      "1": {
        loc: {
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 43,
            column: 60
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 43,
            column: 60
          }
        }, {
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 43,
            column: 60
          }
        }],
        line: 43
      },
      "2": {
        loc: {
          start: {
            line: 64,
            column: 6
          },
          end: {
            line: 64,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 64,
            column: 6
          },
          end: {
            line: 64,
            column: 32
          }
        }, {
          start: {
            line: 64,
            column: 6
          },
          end: {
            line: 64,
            column: 32
          }
        }],
        line: 64
      },
      "3": {
        loc: {
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 69,
            column: 58
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 69,
            column: 58
          }
        }, {
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 69,
            column: 58
          }
        }],
        line: 69
      },
      "4": {
        loc: {
          start: {
            line: 73,
            column: 6
          },
          end: {
            line: 73,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 73,
            column: 6
          },
          end: {
            line: 73,
            column: 32
          }
        }, {
          start: {
            line: 73,
            column: 6
          },
          end: {
            line: 73,
            column: 32
          }
        }],
        line: 73
      },
      "5": {
        loc: {
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 74,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 74,
            column: 52
          }
        }, {
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 74,
            column: 52
          }
        }],
        line: 74
      },
      "6": {
        loc: {
          start: {
            line: 74,
            column: 10
          },
          end: {
            line: 74,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 10
          },
          end: {
            line: 74,
            column: 25
          }
        }, {
          start: {
            line: 74,
            column: 29
          },
          end: {
            line: 74,
            column: 44
          }
        }],
        line: 74
      },
      "7": {
        loc: {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 38
          }
        }, {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 38
          }
        }],
        line: 78
      },
      "8": {
        loc: {
          start: {
            line: 78,
            column: 10
          },
          end: {
            line: 78,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 78,
            column: 10
          },
          end: {
            line: 78,
            column: 18
          }
        }, {
          start: {
            line: 78,
            column: 22
          },
          end: {
            line: 78,
            column: 30
          }
        }],
        line: 78
      },
      "9": {
        loc: {
          start: {
            line: 83,
            column: 6
          },
          end: {
            line: 83,
            column: 76
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 83,
            column: 6
          },
          end: {
            line: 83,
            column: 76
          }
        }, {
          start: {
            line: 83,
            column: 6
          },
          end: {
            line: 83,
            column: 76
          }
        }],
        line: 83
      },
      "10": {
        loc: {
          start: {
            line: 87,
            column: 6
          },
          end: {
            line: 87,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 87,
            column: 6
          },
          end: {
            line: 87,
            column: 32
          }
        }, {
          start: {
            line: 87,
            column: 6
          },
          end: {
            line: 87,
            column: 32
          }
        }],
        line: 87
      },
      "11": {
        loc: {
          start: {
            line: 90,
            column: 6
          },
          end: {
            line: 90,
            column: 54
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 90,
            column: 6
          },
          end: {
            line: 90,
            column: 54
          }
        }, {
          start: {
            line: 90,
            column: 6
          },
          end: {
            line: 90,
            column: 54
          }
        }],
        line: 90
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/hoc/draggable.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { curry } from '../utils/func';
var defaultProps = (cov_1yd3xfa3ku.s[0]++, {
  client: undefined,
  onDragStart: function onDragStart() {
    cov_1yd3xfa3ku.f[0]++;
  },
  onDrag: function onDrag() {
    cov_1yd3xfa3ku.f[1]++;
  },
  onDragEnd: function onDragEnd() {
    cov_1yd3xfa3ku.f[2]++;
  }
});
export default curry(function (OriginComponent) {
  cov_1yd3xfa3ku.f[3]++;

  var Drag =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(Drag, _PureComponent);

    var _super = _createSuper2(Drag);

    function Drag(props) {
      var _this;

      _classCallCheck(this, Drag);

      cov_1yd3xfa3ku.f[4]++;
      cov_1yd3xfa3ku.s[1]++;
      _this = _super.call(this, props);
      _this.clientX = void 0;
      _this.clientY = void 0;
      _this.dragging = void 0;
      cov_1yd3xfa3ku.s[2]++;
      _this.handleDragStart = _this.handleDragStart.bind(_assertThisInitialized(_this));
      cov_1yd3xfa3ku.s[3]++;
      _this.handleDrag = _this.handleDrag.bind(_assertThisInitialized(_this));
      cov_1yd3xfa3ku.s[4]++;
      _this.handleDragEnd = _this.handleDragEnd.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(Drag, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        cov_1yd3xfa3ku.f[5]++;

        var _ref = (cov_1yd3xfa3ku.s[5]++, this.props),
            client = _ref.client;

        cov_1yd3xfa3ku.s[6]++;

        if (client) {
          cov_1yd3xfa3ku.b[0][0]++;
          cov_1yd3xfa3ku.s[7]++;
          this.clientX = client.x;
          cov_1yd3xfa3ku.s[8]++;
          this.clientY = client.y;
          cov_1yd3xfa3ku.s[9]++;
          this.dragging = true;
          cov_1yd3xfa3ku.s[10]++;
          this.addEvents();
          cov_1yd3xfa3ku.s[11]++;

          if (this.props.onDragStart) {
            cov_1yd3xfa3ku.b[1][0]++;
            cov_1yd3xfa3ku.s[12]++;
            this.props.onDragStart();
          } else {
            cov_1yd3xfa3ku.b[1][1]++;
          }
        } else {
          cov_1yd3xfa3ku.b[0][1]++;
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        cov_1yd3xfa3ku.f[6]++;
        cov_1yd3xfa3ku.s[13]++;
        this.removeEvents();
      }
    }, {
      key: "addEvents",
      value: function addEvents() {
        cov_1yd3xfa3ku.f[7]++;
        cov_1yd3xfa3ku.s[14]++;
        document.addEventListener('mousemove', this.handleDrag);
        cov_1yd3xfa3ku.s[15]++;
        document.addEventListener('mouseup', this.handleDragEnd);
        cov_1yd3xfa3ku.s[16]++;
        document.addEventListener('mouseleave', this.handleDragEnd);
      }
    }, {
      key: "removeEvents",
      value: function removeEvents() {
        cov_1yd3xfa3ku.f[8]++;
        cov_1yd3xfa3ku.s[17]++;
        document.removeEventListener('mousemove', this.handleDrag);
        cov_1yd3xfa3ku.s[18]++;
        document.removeEventListener('mouseup', this.handleDragEnd);
        cov_1yd3xfa3ku.s[19]++;
        document.removeEventListener('mouseleave', this.handleDragEnd);
      }
    }, {
      key: "handleDragStart",
      value: function handleDragStart(e) {
        cov_1yd3xfa3ku.f[9]++;
        cov_1yd3xfa3ku.s[20]++;

        if (e.button !== 0) {
          cov_1yd3xfa3ku.b[2][0]++;
          cov_1yd3xfa3ku.s[21]++;
          return;
        } else {
          cov_1yd3xfa3ku.b[2][1]++;
        }

        cov_1yd3xfa3ku.s[22]++;
        this.clientX = e.clientX;
        cov_1yd3xfa3ku.s[23]++;
        this.clientY = e.clientY;
        cov_1yd3xfa3ku.s[24]++;
        this.dragging = true;
        cov_1yd3xfa3ku.s[25]++;
        this.addEvents();
        cov_1yd3xfa3ku.s[26]++;

        if (this.props.onDragStart) {
          cov_1yd3xfa3ku.b[3][0]++;
          cov_1yd3xfa3ku.s[27]++;
          this.props.onDragStart();
        } else {
          cov_1yd3xfa3ku.b[3][1]++;
        }
      }
    }, {
      key: "handleDrag",
      value: function handleDrag(e) {
        cov_1yd3xfa3ku.f[10]++;
        cov_1yd3xfa3ku.s[28]++;

        if (!this.dragging) {
          cov_1yd3xfa3ku.b[4][0]++;
          cov_1yd3xfa3ku.s[29]++;
          return;
        } else {
          cov_1yd3xfa3ku.b[4][1]++;
        }

        cov_1yd3xfa3ku.s[30]++;

        if ((cov_1yd3xfa3ku.b[6][0]++, e.clientX === 0) && (cov_1yd3xfa3ku.b[6][1]++, e.clientY === 0)) {
          cov_1yd3xfa3ku.b[5][0]++;
          cov_1yd3xfa3ku.s[31]++;
          return;
        } else {
          cov_1yd3xfa3ku.b[5][1]++;
        }

        var mx = (cov_1yd3xfa3ku.s[32]++, e.clientX - this.clientX);
        var my = (cov_1yd3xfa3ku.s[33]++, e.clientY - this.clientY);
        cov_1yd3xfa3ku.s[34]++;

        if ((cov_1yd3xfa3ku.b[8][0]++, mx === 0) && (cov_1yd3xfa3ku.b[8][1]++, my === 0)) {
          cov_1yd3xfa3ku.b[7][0]++;
          cov_1yd3xfa3ku.s[35]++;
          return;
        } else {
          cov_1yd3xfa3ku.b[7][1]++;
        }

        cov_1yd3xfa3ku.s[36]++;
        this.clientX = e.clientX;
        cov_1yd3xfa3ku.s[37]++;
        this.clientY = e.clientY;
        cov_1yd3xfa3ku.s[38]++;

        if (this.props.onDrag) {
          cov_1yd3xfa3ku.b[9][0]++;
          cov_1yd3xfa3ku.s[39]++;
          this.props.onDrag(mx, my, e.clientX, e.clientY);
        } else {
          cov_1yd3xfa3ku.b[9][1]++;
        }
      }
    }, {
      key: "handleDragEnd",
      value: function handleDragEnd() {
        cov_1yd3xfa3ku.f[11]++;
        cov_1yd3xfa3ku.s[40]++;

        if (!this.dragging) {
          cov_1yd3xfa3ku.b[10][0]++;
          cov_1yd3xfa3ku.s[41]++;
          return;
        } else {
          cov_1yd3xfa3ku.b[10][1]++;
        }

        cov_1yd3xfa3ku.s[42]++;
        this.dragging = false;
        cov_1yd3xfa3ku.s[43]++;
        this.removeEvents();
        cov_1yd3xfa3ku.s[44]++;

        if (this.props.onDragEnd) {
          cov_1yd3xfa3ku.b[11][0]++;
          cov_1yd3xfa3ku.s[45]++;
          this.props.onDragEnd();
        } else {
          cov_1yd3xfa3ku.b[11][1]++;
        }
      }
    }, {
      key: "render",
      value: function render() {
        cov_1yd3xfa3ku.f[12]++;
        cov_1yd3xfa3ku.s[46]++;
        return (
          /*#__PURE__*/
          React.createElement(OriginComponent, Object.assign({}, this.props, {
            onDragStart: this.handleDragStart,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 94,
              columnNumber: 14
            }
          }))
        );
      }
    }]);

    return Drag;
  }(PureComponent);

  Drag.defaultProps = defaultProps;
  cov_1yd3xfa3ku.s[47]++;
  return Drag;
});